<template>
  <div>
    <c-card reference="Climb > Profissões" title="Profissões">
      <template slot="icons">
        <icon class="icon" @click="novaProfissao" icon="plus"></icon>
        <icon class="icon" @click="abrirFiltros" icon="filter">
          <span v-if="totalFilters" class="card-icons-alert"
            >@{{ totalFilters }}</span
          >
        </icon>
      </template>
      <c-list :items="profissoes" class="mb-3">
        <template v-slot:items="item">
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex flex-column">
              <div>
                <span
                  style="font-size: .9em; color: #222; font-weight: bold;"
                  >{{ item.data.nome }}</span
                >
              </div>
            </div>
            <div class="list-icons">
              <icon
                class="icon"
                @click="editarProfissao(item.data)"
                icon="pen"
              ></icon>
            </div>
          </div>
        </template>
      </c-list>
      <span class="card-divisor mb-3"></span>

      <div class="d-flex justify-content-between">
        <span style="font-size: .8em;font-weight: bold;">
          {{ (page - 1) * limit + 1 }} -
          {{ page * limit > totalRows ? totalRows : page * limit }} /
          {{ totalRows }}
        </span>
        <b-pagination
          v-model="page"
          :total-rows="totalRows"
          :per-page="limit"
          aria-controls="my-table"
          pills
          size="sm"
          class="mb-0"
          @change="loadProfissoes"
        ></b-pagination>
      </div>
    </c-card>

    <c-modal title="Profissão" v-model="modalProfissoes" size="full">
      <template v-slot:buttons>
        <button v-if="!loading" @click="salvarProfissao">Salvar</button>
        <button v-else @click="salvarProfissao" :disabled="loading">
          <b-spinner class="mr-2" small></b-spinner> Cadastrando profissão
        </button>
      </template>

      <b-row>
        <b-col>
          <b-form-group
            label-size="sm"
            v-for="(field, i) in commonFields"
            :key="i"
            :label="field.name"
            :label-for="field.attribute"
          >
            <b-form-input
              id="field.attribute"
              v-if="field.attribute != 'senha'"
              v-model="profissao[field.attribute]"
              type="text"
              :disabled="loading"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </c-modal>

    <c-modal title="Filtro" v-model="modalFiltro" size="md">
      <template v-slot:buttons>
        <button @click="limparFiltros">Limpar</button>
        <button @click="filtrarProfissoes">Filtrar</button>
      </template>
      <b-row>
        <b-col>
          <b-form-group label-size="sm" label="Nome" label-for="filtro-nome">
            <b-form-input
              id="filtro-nome"
              v-model="temporaryFilters.nome"
              type="text"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </c-modal>
  </div>
</template>

<script>
import profissoesService from "@/services/profissoesService.js";

import CList from "@/components/CList.vue";
import CCard from "@/components/CCard.vue";
import CModal from "@/components/CModal.vue";

import { mapActions } from "vuex";

export default {
  name: "Profissoes",
  data() {
    return {
      profissoes: [],
      profissao: [],
      modalProfissoes: false,
      commonFields: [{ name: "Nome", attribute: "nome" }],
      modalFiltro: false,
      temporaryFilters: {},
      loading: false,
      filters: {
        nome: null
      },
      limit: 15,
      page: 1,
      totalRows: 0
    };
  },
  methods: {
    ...mapActions("notification", { notificate: "add" }),
    loadProfissoes(pageNumber) {
      profissoesService
        .getAll(this.limit, pageNumber, this.filters)
        .then(res => {
          this.profissoes = res.data.data;
          this.totalRows = res.data.totalRows;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    abrirFiltros() {
      this.temporaryFilters = JSON.parse(JSON.stringify(this.filters));
      this.modalFiltro = true;
    },
    filtrarProfissoes() {
      this.page = 1;
      this.modalFiltro = false;
      this.filters = JSON.parse(JSON.stringify(this.temporaryFilters));
      this.loadProfissoes();
    },
    novaProfissao() {
      this.profissao = {
        nome: null
      };

      this.loading = false;
      this.modalProfissoes = true;
    },
    limparFiltros() {
      Object.keys(this.temporaryFilters).forEach(k => {
        this.temporaryFilters[k] = null;
      });
    },
    salvarProfissao() {
      this.loading = true;

      if (this.profissao.id) {
        profissoesService
          .update(this.profissao.id, this.profissao)
          .then(res => {
            this.loading = false;

            if (res.data.errors) {
              Object.keys(res.data.errors).forEach(k => {
                res.data.errors[k].forEach(e => {
                  this.notificate({ text: e, variant: "danger" });
                });
              });
              return;
            }

            this.modalProfissoes = false;

            res = "Profissão alterada com sucesso";

            this.loadProfissoes();

            this.notificate({ text: res, variant: "success" });
          })
          .catch(err => {
            this.loading = false;
            this.notificate({ text: err.message, variant: "danger" });
          });
      } else {
        profissoesService
          .create(this.profissao)
          .then(res => {
            this.loading = false;

            if (res.data.errors) {
              Object.keys(res.data.errors).forEach(k => {
                res.data.errors[k].forEach(e => {
                  this.notificate({ text: e, variant: "danger" });
                });
              });
              return;
            }

            this.modalProfissoes = false;

            res = "Profissão cadastrada com sucesso";

            this.loadProfissoes();

            this.notificate({ text: res, variant: "success" });
          })
          .catch(err => {
            this.loading = false;
            this.notificate({ text: err.message, variant: "danger" });
          });
      }
    },
    editarProfissao(profissao) {
      this.profissao = {
        ...JSON.parse(JSON.stringify(profissao))
      };

      this.modalProfissoes = true;
    }
  },
  components: {
    CList,
    CCard,
    CModal
  },
  computed: {
    totalFilters() {
      return Object.keys(this.filters).filter(
        k => this.filters[k] && this.filters[k] != ""
      ).length;
    }
  },
  mounted() {
    this.loadProfissoes(1);
  }
};
</script>
